import behave from "./helpers/behave";

behave('.clients', element => {
    const children = Array.from(element.querySelectorAll('.client'))

    let prev

    const tick = (time) => {
        if (prev) {
            const dt = time - prev
            element.scrollLeft += dt / 7

            if (element.scrollLeft > window.innerWidth / 2) {
                const child = children.shift();
                const left = children[0].offsetLeft

                element.appendChild(child);
                children.push(child);

                element.scrollLeft -= left - children[0].offsetLeft
            }
        }

        prev = time

        requestAnimationFrame(tick)
    }

    requestAnimationFrame(tick)
})
